/* eslint-disable @typescript-eslint/camelcase */
const ButtonNames = {
  DOWNLOAD_CONTRACT_BUTTON: 'newObserve_Download_Contract_Button',
  DOWNLOAD_ADDITIONAL_SERVICE_DOCUMENT: 'newObserve_Download_Additional_Service_Document_Button',
  PRINT_NOTIFICATION_BUTTON: 'newObserve_Print_Notification_Button',
  DOWNLOAD_CLIENTS_APPLICATION_FORM: 'newObserve_Download_Clients_Application_Button',
  DOWNLOAD_INSURANCE_APPLICATION: 'newObserve_Download_Insurance_Application_Button',
  CLOSE_AN_INACTIVE_CONTRACT: 'newObserve_Close_An_Inactive_Contract_Button',
  DOWNLOAD_POWER_OF_ATTORNEY: 'newObserve_Download_Power_Of_Attorney_Button',
  DOWNLOAD_REPRESENTATIVES_STATEMENTS: 'newObserve_Download_Representatives_Statements_Button',
  CASCO_INSURANCE_POLICY: 'newObserve_Casco_Insurance_Policy_Button',
  DOWNLOAD_THE_LETTER_OF_CREDIT: 'newObserve_Download_The_Letter_Of_Credit_Button',
  DOWNLOAD_THE_APPLICATION_BY_SMS: 'newObserve_Download_The_Application_By_Sms_Button',
  CLOSE_ACTIVE_AGREMEENT: 'newObserve_Close_Active_Agreement_Button',
  DOWNLOAD_GUARANTEE_AGREEMENT: 'newObserve_Download_Guarentee_Agreement_Button',
  CANCEL_CLOSING_OF_ACTIVE_CONTRACT: 'newObserve_Cancel_Closing_Of_Active_Contract_Button',
};
export const ButtonTranslations: any = {
  newObserve_Download_Contract_Button: 'newObserve_downloadContract_button',
  newObserve_Download_Additional_Service_Document_Button:
    'newObserve_additionalServiceDocument_button',
  newObserve_Print_Notification_Button: 'newObserve_printNotification_button',
  newObserve_Download_Clients_Application_Button: 'newObserve_clientApplicationForm_button',
  newObserve_Download_Insurance_Application_Button:
    'newObserve_downloadInsuranceApplication_button',
  newObserve_Close_An_Inactive_Contract_Button: 'newObserve_closeInactiveContract_button',
  newObserve_Download_Power_Of_Attorney_Button: 'newObserve_downloadPowerOfAttorney_button',
  newObserve_Download_Representatives_Statements_Button:
    'newObserve_downloadRepresentativeStatement_button',
  newObserve_Casco_Insurance_Policy_Button: 'newObserve_cascoInsurancePolicy_button',
  newObserve_Download_The_Letter_Of_Credit_Button: 'newObserve_downloadCreditLetter_button',
  newObserve_Download_The_Application_By_Sms_Button: 'newObserve_downloadApplicationBySMS_button',
  newObserve_Close_Active_Agreement_Button: 'newObserve_closeActiveContract_button',
  newObserve_Download_Guarentee_Agreement_Button: 'newObserve_guaranteeAgreement_button',
  newObserve_Cancel_Closing_Of_Active_Contract_Button:
    'newObserve_cancelClosingActiveContract_button',
};
export const ConfirmTranslations: any = {
  newObserve_Close_An_Inactive_Contract_Button: 'newObserve_cancelRequestConfirmation_text',
  newObserve_Close_Active_Agreement_Button: 'newObserve_cancelActiveContractConfirmation_text',
  newObserve_Cancel_Closing_Of_Active_Contract_Button:
    'newObserve_cancelClosingContractConfirmation_text',
};
export default ButtonNames;
